namespace SP.Data {
    export class Statistics {

        static async get(key: string, from: string, to: string, grouping: StatGroup, userId: string = null) {
            //if (useCache && this.itemInfo[itemId] != null) return this.itemInfo[itemId];

            var url = `/api/v1/statistics/get/${key}?from=${from}&to=${to}&group=${grouping}`;
            if (userId) url += `&user=${userId}`;
            var response = await SP.get<any>(url);
            if (response.status == 200) return response.data; // this.itemInfo[itemId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
        }

    }
}